import { Truck } from "lucide-react";
import { money } from "../../lib/api";

export const courierKey = p => `${p.courier_code}:${p.courier_service_code}`;

export const CourierOptions = ({ pricing, selected, onSelect, allowManual = true, id = "shipping-option", busy = false, error = "" }) => <div className="courier-options" data-testid={`${id}-list`}>
  {busy && <p className="muted" data-testid={`${id}-loading`}>Menghitung ongkir…</p>}
  {error && <p className="form-error" role="alert" data-testid={`${id}-error`}>{error}</p>}
  {pricing.map(p => { const key = courierKey(p), active = selected === key; return <label key={key} className={`courier-option ${active ? "active" : ""}`} data-testid={`${id}-${p.courier_code}-${p.courier_service_code}`}>
    <input type="radio" name={id} value={key} checked={active} onChange={() => onSelect(key)}/>
    <Truck size={18}/>
    <span className="courier-name"><b>{p.courier_name}</b> {p.service_name}<small>{p.duration}{p.shipping_type === "freight" ? " · kargo" : p.service_type === "instant" || p.service_type === "same_day" ? " · instan" : ""}</small></span>
    <strong>{money(p.price)}</strong>
  </label>; })}
  {allowManual && <label className={`courier-option ${selected === "" ? "active" : ""}`} data-testid={`${id}-manual`}>
    <input type="radio" name={id} value="" checked={selected === ""} onChange={() => onSelect("")}/>
    <Truck size={18}/>
    <span className="courier-name"><b>Ongkir dikonfirmasi sales</b><small>Armada MASES / kargo besar (pasir, batu, semen curah)</small></span>
    <strong>—</strong>
  </label>}
</div>;
